import React from "react";
import { useTranslation } from "react-i18next";

import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

import pic1 from "./images/aboutus/pexels-fauxels-3183150.jpg";
import pic2 from "./images/aboutus/colleagues-working-project-discussing-details.jpg";
import pic3 from "./images/aboutus/pexels-rdne-7414284.jpg";
import './styles/AboutUsStyles.css';

function AboutUs() {
    const { t } = useTranslation();
    return (
        <>
            <SEO
                title={t('about.seoTitle')}
                description={t('about.seoDescription')}
                keywords={t('about.seoKeywords')}
                url="/about"
                schemaType="organization"
            />
            <TitleFragment title={t('about.pageTitle')} />
            <section className="about-section">


                {/* Section 1 */}
                <div className="about-row">
                    <div className="about-content">

                        <p><span className="about-us-title"><b>{t('about.companyName')}</b></span>{t('about.p1')}</p>
                        <p>{t('about.p2')}</p>
                    </div>
                    <div className="about-image">
                        <img src={pic2} alt={t('about.visionAlt')} />
                    </div>
                </div>

                {/* Section 2 */}
                <div className="about-row reverse">
                    <div className="about-image">
                        <img src={pic1} alt={t('about.philosophyAlt')} />
                    </div>
                    <div className="about-content">
                        <h2>{t('about.philosophyTitle')}</h2>
                        <p>{t('about.p3')}</p>
                        <p>{t('about.p4')}</p>
                    </div>
                </div>

                {/* Section 3 */}
                <div className="about-row">
                    <div className="about-content">
                        <h2>{t('about.expertiseTitle')}</h2>
                        <p>{t('about.p5')}</p>
                    </div>
                    <div className="about-image">
                        <img src={pic3} alt={t('about.expertiseAlt')} />
                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutUs;